<template lang="pug">
.position-relative
	// Hero for FREE version
	section.section.section-lg.section-hero.heroPlastomex
		div(style='height: fit-content')
			h1.h-titulo Nuestros Productos
			p.lead.h-subtitulo  Contamos con productos de la más alta calidad
	// You write code for this content block in another  file
	section#section-components.section
		.container
			.row.mb-5.justify-content-center
				.h2-box
					h2
						span Nuestros productos
						|  Lo  mejor para tu empresa
			.categorias-productos
				.row
					.col-6.texto
						div
							router-link.btn.btn-primary(to='/rafias') Rafias
					.col-6
						picture
							source(srcset='../../public/img/productos/rafias.webp' type="image/webp")
							img(src='../../public/img/productos/rafias.jpg', width='100%')
				.row
					.col-6
						picture
							source(srcset='../../public/img/productos/Cajas_2.webp' type="image/webp")
							img(src='../../public/img/productos/Cajas_2.jpg', width='100%')
					.col-6.texto
						div
							p Empaque para sus productos.
							router-link.btn.btn-secondary(to='/cajas') Cajas y Tapas
				.row
					.col-6.texto
						div
							p Protegiendo el producto en su tarima.
							router-link.btn.btn-primary(to='/esquineros') Esquineros
					.col-6
						picture
							source(srcset='../../public/img/productos/ESQUINERO.webp' type="image/webp")
							img(src='../../public/img/productos/ESQUINERO.jpg', width='100%')
	.barra_media
		h5 ¿Necesitas alguno de nuestros productos?
		router-link.btn.btn-secondary(to='/contacto#contacto') Contáctanos

</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>
.heroPlastomex{
	background-image: url('/img/optimizadas/PRODUCTOS.jpg')
}
.webp .heroPlastomex{
	background-image: url('/img/optimizadas/PRODUCTOS.webp')
}
</style>